import { takeLatest, select, call, apply, put } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import { logAPI } from "../api/andyliticsApi";
import * as portalApi from "../api/portalApi";

export default function* commonSaga() {
    yield takeLatest(types.GET_APP_UPDATE, handleAppUpdates, portalApi.getAppUpdate, 'Saga.GetAppUpdate');
}

export function* handle(apiCall, authToken, andyliticsLogName, action) {
    const type = action.type;
    const start = new Date();
    const data = action.data;

    try {
        let response = null;
        if (typeof data === 'object') {
            const args = [authToken];
            for (let i in data) {
                args.push(data[i]);
            }
            response = yield apply(null, apiCall, args);
        }
        else {
            response = yield call(apiCall, authToken, data);
        }

        if (andyliticsLogName) {
            logAPI(andyliticsLogName, start, null);
        }

        yield put({ type: type, success: true, data: response });
    }
    catch (error) {
        console.error(error, apiCall, action);
        if (error !== null && error.status !== 401) {
            yield put({ type: type, failure: true, error: error });
        }

        if (andyliticsLogName) {
            logAPI(andyliticsLogName + '.Failure', start, null, error);
        }
    }
}

function* handleAppUpdates(apiCall, andyliticsLogName, action) {
    const domainData = yield select((state) => state.domain);

    try {
        if (!action.success && !action.error) {
            yield call(handle, apiCall, domainData.t, andyliticsLogName, action);
        }
    }
    catch (error) {
        console.error(error);
    }
}